/**
 * `/merchandising/styles/$styleId/design` — redirects to the unified visual
 * editor with the Design tab active. The Design Studio's canvas, marking
 * placement, Alan proposals, and buyer sign-off now live inside the Visual
 * Editor's "Design" tab.
 *
 * @see $styleId.visual.tsx — the unified editor route
 * @see redesign-phases.md — Phase 1
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/design/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/merchandising/styles/$styleId/visual",
      params: { styleId: params.styleId },
      search: { tab: "design" as const },
    });
  },
});
